import { useSitecoreContext } from 'hooks/useSitecoreContext';
import ScLink from 'components/Generic/SitecoreWrappers/ScLink';
import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import styles from './styles/Link.module.scss';

interface LinkProps {
  fields: {
    link?: {
      value?: {
        href: string;
      };
    };
  };
}

const Link = ({ fields }: LinkProps): JSX.Element | null => {
  const { sitecoreContext } = useSitecoreContext();

  if (!fields?.link?.value?.href) return null;

  return sitecoreContext.pageEditing || fields?.link?.value ? (
    <div className={styles.linkWrapper}>
      <ScLink
        className="revert-underline text-link background-to-change"
        field={fields.link as unknown as LinkField}
      />
    </div>
  ) : null;
};

export default Link;
